import * as Sentry from '@sentry/vue'
import { FetchError } from 'ofetch'
import useUIStore from '~/store/ui'

const DEFAULT_ERROR_MESSAGE = 'An unexpected error occurred. Please try again later.'

const useErrorHandler = () => {
  const { showSnackBanner } = useUIStore()

  const captureException = (error: any) => {
    if (process.client) {
      Sentry.captureException(error)
    }
  }

  const isFetchError = (error: any) => {
    return error instanceof FetchError
  }

  const handleErrorResponse = (errorMessage: string, error: any, status: number | null) => {
    switch (status) {
      case 401:
      case 403:
        showSnackBanner(errorMessage, 'error')
        break
      case 500:
        captureException(error)
        showSnackBanner(DEFAULT_ERROR_MESSAGE, 'error')
        break
      default:
        captureException(error)
        showSnackBanner(errorMessage, 'error')
    }
  }

  const getErrorMessage = (error: any) => {
    if (isFetchError(error) && error.response?._data.message) {
      return error.response._data.message
    }

    if (isNuxtError(error)) {
      return error.message
    }

    return DEFAULT_ERROR_MESSAGE
  }

  const getErrorStatus = (error: any) => {
    if (isFetchError(error) && error.response?.status) {
      return error.response.status
    }

    if (isNuxtError(error)) {
      return error.statusCode
    }

    return null
  }

  const catchErrors = (error: any) => {
    // eslint-disable-next-line security-node/detect-crlf, no-console
    console.log(error)

    if (isFetchError(error) || isNuxtError(error)) {
      handleErrorResponse(getErrorMessage(error), error, getErrorStatus(error))
    } else {
      captureException(error)
      showSnackBanner(DEFAULT_ERROR_MESSAGE, 'error')
    }
  }

  return {
    catchErrors,
  }
}

export default useErrorHandler
